import React from 'react';
import Currency from '@prisjakt/ui-currency';

import { priceLabelStylingType, PriceLabelStyleType } from '../types';

import * as S from './styles';

type OwnProps = {
  className?: string;
  value: number | string | React.ReactNode;
  bold?: boolean;
  styling?: priceLabelStylingType;
};

type Props = OwnProps;

export const PriceLabel = ({
  className,
  value,
  bold = true,
  styling = PriceLabelStyleType.PRIMARY,
}: Props) => {
  return (
    <S.PriceLabel className={className} bold={bold} styling={styling}>
      {typeof value === 'number' ? <Currency price={value} /> : value}
    </S.PriceLabel>
  );
};

export { PriceLabelStyleType as PriceLabelStyle };
